// extracted by mini-css-extract-plugin
export var searchContainer = "cta-search-module--search-container--f1aad";
export var sideColumnTitle = "cta-search-module--side-column-title--1561a";